module.exports = __webpack_public_path__ + "static/media/kk_kindergarten_instruction.fb15893a.pdf";